/**
 * V2 Admin Permissions API client
 *
 * Pacote 6 — Sub-perfis Administrativos (Gestão de Admins).
 * Spec: docs/V2/07_REGRAS_NEGOCIO.md §15
 *
 * Endpoints: /api/v2/admin/permissions
 *   GET    /areas            — metadados de áreas/levels + limite de Admin Masters
 *   GET    /admins           — lista admins + permissões agregadas
 *   POST   /users/:userId    — upsert permissões (pode retornar 422 BUSINESS_RULE)
 *   DELETE /users/:userId    — revoga TODAS permissões
 */

import v2Api from './index';

export const adminPermissionsV2API = {
  /** Metadados: { success, areas, levels, max_admin_masters } */
  getAreas: () => v2Api.get('/admin/permissions/areas'),

  /** Lista admins com permissões agregadas: { success, admins: [...] } */
  listAdmins: () => v2Api.get('/admin/permissions/admins'),

  /**
   * Upsert permissões de um admin.
   * Body: { permissions: [{ area, can_view, can_edit, can_approve, can_delete }, ...] }
   * Pode retornar 403 FORBIDDEN ou 422 BUSINESS_RULE quando "Limite de 3 Admin Masters atingido".
   */
  setPermissions: (userId, body) =>
    v2Api.post(`/admin/permissions/users/${userId}`, body),

  /** Revoga TODAS permissões de um admin. */
  revokeAll: (userId) => v2Api.delete(`/admin/permissions/users/${userId}`),

  /**
   * Pacote 8 — Promove user existente a admin + atribui permissões em 1 chamada.
   * Body: { email, permissions: [...] }
   * Pode retornar 404 NOT_FOUND (email não cadastrado) ou 422 BUSINESS_RULE
   * (limite 3 Admin Masters).
   */
  promote: (body) => v2Api.post('/admin/permissions/promote', body),
};

export default adminPermissionsV2API;
